/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Stack_MemoryInputs */



/**
* | output |
* | --- |
* | "Show the colleagues with conversation info" |
*
* @param {Team_Stack_MemoryInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const team_stack_memory = /** @type {((inputs?: Team_Stack_MemoryInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Stack_MemoryInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Toon de collega's met gespreksinfo")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Afficher les collègues avec des infos d'entretien")
	return /** @type {LocalizedString} */ ("Show the colleagues with conversation info")
});